<template>
  <div class="mt-32 md:mt-40">
    <AppContainer>
      <div class="flex w-full flex-col items-center gap-10 md:gap-32 xl:flex-row">
        <div class="flex flex-col gap-8 md:w-[553px]">
          <h2 class="heading-primary text-center text-3xl font-bold md:text-[54px] md:leading-tight xl:text-left">
            Why join our <br>
            <em>Certification Program</em>
          </h2>
          <p class="text-center text-sm text-eerie-black md:text-lg xl:text-left dark:text-body-gray">
            Built in collaboration with Vue School and industry experts, our Certification Programs are designed to ensure the competencies tested are those necessary to achieve the effective use of the frameworks, plugins, and tools we certify.
            <br>
            <br>
            Examinations are challenging, so you have a true opportunity to prove your worth. Included are real-world coding challenges which are a fun, interactive way! Preparation materials and training are provided, allowing you to expand your knowledge and gain a deep understanding of the technology. Advanced certification is also provided for those that are or aspire to a senior role.
          </p>
        </div>
        <div class="flex flex-1 justify-center md:w-4/5 xl:w-full ">
          <div class=" mx-auto hidden w-[600px] shrink-0 flex-wrap justify-center  gap-8 md:flex">
            <div
              v-for="item in 5"
              :key="item"
              class="group w-auto"
              :class="{'-mt-10': item > 3 }">
              <NuxtImg
                width="153"
                height="170"
                :src="`/images/pitch/${item}.svg`"
                class="pointer-events-none hidden group-hover:hidden dark:block"
                :alt="`${item}`" />
              <NuxtImg
                width="153"
                height="170"
                :src="`/images/pitch/${item}-light.svg`"
                class="pointer-events-none group-hover:hidden dark:hidden"
                :alt="`${item}`" />
              <NuxtImg
                width="153"
                height="170"
                :src="`/images/pitch/${item}-hover.svg`"
                class="hidden w-[152px] transition delay-75 duration-100 ease-linear hover:scale-110 dark:hidden dark:group-hover:block"
                :alt="`${item}`" />
              <NuxtImg
                width="153"
                height="170"
                :src="`/images/pitch/${item}-light-hover.svg`"
                class="hidden w-[152px] transition delay-75 duration-100 ease-linear hover:scale-110 group-hover:block dark:hidden dark:group-hover:hidden"
                :alt="`${item}`" />
            </div>
          </div>
          <div class=" flex w-[350px] shrink-0 flex-wrap justify-center  gap-4 md:hidden">
            <div
              v-for="item in 5"
              :key="item"
              class="group w-auto"
              :class="{'-mt-6': item > 3 }">
              <NuxtImg
                :src="`/images/pitch/${item}-hover.svg`"
                class=" hidden w-24 dark:block"
                :alt="`${item}`" />
              <NuxtImg
                :src="`/images/pitch/${item}-light-hover.svg`"
                class=" w-24 dark:hidden"
                :alt="`${item}`" />
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  </div>
</template>
